export default __webpack_public_path__ + "static/media/cushion.ffd05164.jpg";